<template>
    <transition name="fade">
        <div id="questionnaire-start">
            <div class="tips-action">
                Cliquez sur l'écran <br> de l'ordinateur
                <img src="@/assets/svg/hand_up.svg"
                     alt="Symbole en forme de main indiquant l'endroit où l'utilisateur dois intéragir">
            </div>
            <div class="transparent-action" @click="emit"></div>
        </div>
    </transition>
</template>
<script>
    export default {
        name: 'QuestionnaireAction',
        methods: {
            emit() {
                this.$emit('go')
                this.$parent.video.pause()
            }
        }
    }
</script>

<style lang="scss" scoped>
    #questionnaire-start {
        .tips-action {
            text-align: center;
            font-size: 1.875rem;
            color: #fff;
            font-family: 'Roboto Condensed', sans-serif;
            position: absolute;
            width: 23%;
            height: 28%;
            z-index: 2;
            top: 22%;
            left: 19%;
            img {
                width: 20%;
                display: block;
                margin: 20px auto auto auto;
                animation: hand-animation 700ms ease-in-out infinite alternate;
            }
            @keyframes hand-animation {
                0% {
                    transform: translateY(0px);
                }
                100% {
                    transform: translateY(20px);
                }
            }
        }

        .transparent-action {
            position: absolute;
            width: 28%;
            height: 33%;
            top: 54%;
            left: 16%;
            background-color: transparent;
            transform: rotateZ(-2deg);
            cursor: pointer;
        }
    }


</style>
